export function init(accountId, organizationArray){

    (function(apiKey){(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
        v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.eu.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');

        // Call this whenever information about your visitors becomes available
        // Please use Strings, Numbers, or Bools for value types.
        if(organizationArray){
            pendo.initialize({
                visitor: {
                    id: accountId // Required if user is logged in; values = unikátní user ID
                    // email: // Recommended if using Pendo Feedback, or NPS Email
                    // full_name: // Recommended if using Pendo Feedback
                    // role: // Optional
                    // You can add any additional visitor level key-values here,
                    // as long as it's not one of the above reserved names.
                },
                account: {
                    id: organizationArray['organizationId'], // Required if using Pendo Feedback; values = team id (as number)
                    name: organizationArray['organizationName'], // Optional; values = team name (for pairing and analysis)
                    is_paying: organizationArray['is_paying'], // Recommended if using Pendo Feedback; values = yes / no
                    // monthly_value:// Recommended if using Pendo Feedback
                    planLevel: organizationArray['planLevel'], // Optional; values = freemium / essential / advanced / premium
                    // planPrice: // Optional
                    // creationDate: // Optional; values = date created
                    // You can add any additional account level key-values here,
                    // as long as it's not one of the above reserved names.
                    teamLifecycleStage: organizationArray['teamLifecycleStage'], // custom; values = trial, limited trial, expired trial, freemium trial, fremium, expired fremium, customer, expired customer
                    gatewaysCount: organizationArray['gatewaysCount'] // custom; values = 0, 1, 2, n
                }
            });
        } else {
            pendo.initialize({
                visitor: {
                    id: accountId // Required if user is logged in; values = unikátní user ID
                    // email: // Recommended if using Pendo Feedback, or NPS Email
                    // full_name: // Recommended if using Pendo Feedback
                    // role: // Optional
                    // You can add any additional visitor level key-values here,
                    // as long as it's not one of the above reserved names.
                }
            });
        }
    })('55292c2a-11f3-41d4-4233-a2e0274b7522');
}


